<template>
  <v-widget
    v-if="territory"
    :title="territory.country_code | country"
  >
    <div slot="widget-content">
      <div
        class="headline mb-5"
      >{{ $t('Territory') }}</div>
      <country-select
        v-model="territory.country_code"
        :error-messages="verrors('country_code')"
        :label="$t('Country code')"
        outline
      />
      <region-select
        :country="territory.country_code"
        v-model="territory.administrative_area"
        :label="$t('Administrative Area')"
        outline
        clearable
      />
      <v-text-field
        v-model="territory.locality"
        :label="$t('Locality')"
        outline
      />
      <v-text-field
        v-model="territory.dependent_locality"
        :label="$t('Dependent Locality')"
        outline
      />
      <v-text-field
        v-model="territory.included_postal_codes"
        :label="$t('Included postal codes')"
        outline
      />
      <v-text-field
        v-model="territory.excluded_postal_codes"
        :label="$t('Excluded postal codes')"
        outline
      />
    </div>
  </v-widget>
</template>

<script>
import RegionSelect from '@/components/widgets/RegionSelect'
import CountrySelect from '@/components/widgets/CountrySelect'
export default {
  name: 'TerritoryForm',
  components: { CountrySelect, RegionSelect },
  props: {
    territory: {
      type: Object,
      default: null
    }
  },

  computed: {
    verrors () {
      return field => {
        if (!this.territory.errors) {
          return []
        }
        return this.territory.errors
          .filter(obj => obj.field === field)
          .map(obj => obj.message)
          .flat()
      }
    }
  }
}
</script>
